import React, { useContext, useEffect, useReducer } from 'react';
import { reducer } from './privacyReducer';
import { udpAnalyticsIdStorage } from '../../storage/udp-analytics-id-storage';
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {
  isRequired: true,
  isConsentGiven: false
};
export const PolicyStateContext = /*#__PURE__*/React.createContext(initialState);

/* TODO may we can inject the current route to the provider. in this case we can use the hook useUcEvent here, and PolicyDispatchContext does no longer needs to be a provider and exposed.
 * Benefit: we already have initial the correct "isRequired" state
 */

export const PolicyDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const PrivacyProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    dispatch({
      type: 'set-analytics-id',
      analyticsId: udpAnalyticsIdStorage.get()
    });
  }, []);
  return /*#__PURE__*/_jsx(PolicyStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(PolicyDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const usePrivacyState = () => {
  const context = useContext(PolicyStateContext);
  if (context === undefined) {
    throw new Error('usePrivacyState must be used within a PrivacyProvider');
  }
  return context;
};
export const usePrivacyDispatch = () => {
  const context = useContext(PolicyDispatchContext);
  if (context === undefined) {
    throw new Error('usePrivacyDispatch must be used within a PrivacyProvider');
  }
  return context;
};
export const useAnalyticsId = () => usePrivacyState().analyticsId;